import { fromJS } from 'immutable';

import {
  fetchRolesRoutine, removeRoleRoutine,
  saveRoleRoutine,
} from '../routines';
import { remove, updateOrAdd } from './helper';

const initialState = fromJS({
  roles: {},
  role: {},
  loading: true,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchRolesRoutine.SUCCESS:
      return state.set('roles', fromJS(action.payload.response || [])).set('loading', false);
    case fetchRolesRoutine.FAILURE:
      return state.set('error', action.error).set('loading', false);
    case saveRoleRoutine.SUCCESS:
      return state.updateIn(['roles','data'], updateOrAdd(fromJS(action.payload.response.data)));
    case removeRoleRoutine.SUCCESS:
      return state.updateIn(['roles','data'], remove(fromJS(action.payload.request)));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/roles.js